import Header from './components/Header';
import Hero from './components/Hero';
import IndexSection from './components/IndexSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import TopicsSection from './components/TopicsSection';
import FaqSection from './components/FaqSection';
import CardsSection from './components/CardsSection';
import RankingSection from './components/RankingSection';
import ContactSection from './components/ContactSection';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import AppSection from './components/AppSection';
import UpdatesSection from './components/UpdatesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <IndexSection />
        <FeaturesSection />
        <MediaSection />
        <CarouselSection />
        <TopicsSection />
        <FaqSection />
        <CardsSection />
        <RankingSection />
        <ContactSection />
        <CommentsSection />
        <AboutSection />
        <AppSection />
        <UpdatesSection />
      </main>
      <Footer />
    </>
  );
}